import { useCookies } from 'next-client-cookies';
import Image from 'components/commercetools-ui/atoms/image';
import Link from 'components/commercetools-ui/atoms/link';
import { normalizeLocale } from 'helpers/hooks/useResolvedLocalizedObject';
import { cleanString } from 'helpers/utils/util';
import { Reference } from 'types/reference';

type UtilityIconsProps = {
  isDark: boolean;
  darkIcon: any;
  lightIcon: any;
  ariaLabel?: string;
  link?: Reference;
  style?: React.CSSProperties;
  isSpan?: boolean;
  ffid?: string;
  onClick?: () => void;
  tabIndex?: number;
};

export const UtilityIcons: React.FC<UtilityIconsProps> = ({
  isDark,
  darkIcon,
  lightIcon,
  ariaLabel,
  link,
  style,
  isSpan = false,
  ffid,
  onClick,
}) => {
  const cookies = useCookies();
  const nextLocale = cookies.get('locale') as string;

  const locale = cookies.get('locale');
  const lang = locale?.split(/[-_]/)[0]?.toLowerCase() ?? 'en';

  const icon = isDark ? darkIcon : lightIcon;
  const media = icon?.media;
  const normalizedLocale = normalizeLocale(nextLocale);
  const formattedffids = ariaLabel?.includes(' ')
    ? ariaLabel?.toLowerCase().replace(/\s+/g, '-')
    : ariaLabel?.toLowerCase();

  let intercomConfiguredUrl = '';

  if (ffid === 'help') {
    if (locale?.toLowerCase() === 'en-us') {
      intercomConfiguredUrl = `${link}/${lang}/`;
    } else {
      intercomConfiguredUrl = `${link}/${locale ?? 'en'}/`;
    }
  }
  const content = (
    <Image
      media={media}
      width={Number(media?.width || 20)}
      height={Number(media?.height || 20)}
      alt={ariaLabel}
      title={icon?.title ? icon.title[normalizedLocale] || icon?.title : ''}
      data-ffid={`img-${ffid ?? cleanString(formattedffids ?? '')}`}
    />
  );

  if (isSpan) {
    return onClick ? (
      <button
        data-ffid="btn-icons"
        type="button"
        style={{ width: media?.width, height: media?.height }}
        onClick={onClick}
      >
        {content}
      </button>
    ) : (
      <span style={{ width: media?.width, height: media?.height }}>{content}</span>
    );
  }

  if (ffid === 'help') {
    return (
      <a
        href={intercomConfiguredUrl as unknown as string}
        target="_blank"
        rel="noopener noreferrer"
        data-ffid={`lnk-${ffid ?? cleanString(formattedffids ?? '')}`}
      >
        {content}
      </a>
    );
  }
  return (
    <Link
      title={ariaLabel}
      aria-label={ariaLabel}
      link={link}
      data-ffid={`lnk-${ffid ?? cleanString(formattedffids ?? '')}`}
      onClick={onClick}
      style={{
        width: media?.width,
        height: media?.height,
        ...style,
      }}
    >
      {content}
    </Link>
  );
};
